module.exports = __webpack_public_path__ + "img/homepage_main.7b37f3b3.jpg";